import { useNavigate, useParams } from 'react-router-dom';

import { UploadContentLayout } from '@/layout';
import { TributeVideosComponent } from '@/pages/Event/components/TributeVideos';

export const UploadContentTributeVideos = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout goBack={() => navigate(`/events/${eventId}/upload-content/requests`)}>
      <TributeVideosComponent id={eventId ?? ''} isMobileView />
    </UploadContentLayout>
  );
};
